import { render } from "./AdminSegments.vue?vue&type=template&id=23930a07"
import script from "./AdminSegments.vue?vue&type=script&lang=js"
export * from "./AdminSegments.vue?vue&type=script&lang=js"

import "./AdminSegments.vue?vue&type=style&index=0&id=23930a07&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__